import axios from "axios";

import api from "./ApiService";
import { getHeaders } from "../helpers/utils";
import { forEach } from "lodash";
import dayjs from "dayjs";

const APP_URL = process.env.REACT_APP_SERVER_URL;

const buildHtml = async (data, options, documentType) => {
  const res = await axios.post(`${APP_URL}documents/buildHtml`, {
    data,
    options,
    documentType,
  });
  return res.data;
};

const getRelatedDocuments = async ({
  estateId,
  documentTypes,
  startDate,
  endDate,
  isCreated,
  withNoInformation = false,
  withContent = false,
}) => {
  const res = await api.post(
    "Document/RelatedDocuments",
    {
      estateId,
      documentTypes,
      startEffectiveDate: !!startDate ? startDate.format("YYYY-MM-DD") : null,
      endEffectiveDate: !!endDate ? endDate.format("YYYY-MM-DD") : null,
      isCreated,
      withNoInformation,
      withContent,
    },
    {
      headers: getHeaders(),
    },
  );
  return res.data;
};

const buildDocument = async (
  htmlContent,
  documentIds,
  estateId,
  documentName,
  documentType,
  startDate,
  saveAfterBuild = false,
) => {
  const res = await api.post(
    "Document/Build",
    {
      htmlContent,
      documentIds,
      estateId,
      documentName,
      documentType,
      saveAfterBuild,
      effectiveDate: startDate.format("YYYY-MM-DD"),
    },
    {
      headers: getHeaders({
        "Content-Type": "application/json",
      }),
      responseType: "blob",
    },
  );
  return res;
};

const saveDocument = async (
  htmlContent,
  documentIds,
  estateId,
  documentName,
) => {
  const res = await api.post(
    "Document/SaveDocument",
    {
      htmlContent,
      documentIds,
      estateId,
      documentName,
    },
    {
      headers: getHeaders(),
    },
  );
  return res;
};

const downloadFile = async (documentId) => {
  return await api.get(`Document/Download/${documentId}`, {
    responseType: "arraybuffer",
    headers: getHeaders(),
  });
};

const deleteFile = async (documentId) => {
  return await api.delete(`Document/${documentId}`, {
    headers: getHeaders(),
  });
};

const uploadDocuments = async (files, associations) => {
  const formData = new FormData();
  const metadata = [];
  forEach(files, (file) => {
    formData.append("file", file.content);
    const effectiveDate =
      !!file.effectiveDate && file.effectiveDate.isValid()
        ? file.effectiveDate.format("YYYY-MM-DD")
        : null;
    metadata.push({
      name: `${file.name}${file.extension}`,
      documentType: file.documentType,
      effectiveDate,
      estateIds: associations[file.uuid],
    });
  });

  formData.append("metadata", JSON.stringify(metadata));

  const res = await api.post("Document/UploadDocuments", formData, {
    headers: getHeaders(),
  });

  return res.data;
};

const updateDoc = async (
  docId,
  { filename, documentTypeId, effectiveDate },
) => {
  const res = await api.post(
    `Document/${docId}`,
    { filename, documentTypeId, effectiveDate },
    {
      headers: getHeaders(),
    },
  );
  return res;
};

const DocumentsService = {
  buildHtml,
  getRelatedDocuments,
  buildDocument,
  saveDocument,
  downloadFile,
  deleteFile,
  uploadDocuments,
  updateDoc,
};

export default DocumentsService;
